import { Injectable } from '@angular/core';
import { activitiesTypes, currencyTypes, eduGradesType, genderType, maritalTypes, militeryServiceType, organRrank, perHourTypes, presenceTypes, profileRequiredData } from 'src/app/shared/config/data-type';
type type = 'presenceTypes'|'activitiesTypes'|'militaryServiceType'|'eduGradesType'|'maritalType'|'currencyTypes'|'genderType'|'perHourTypes'|'organRank'|'profileRequiredData'
enum Etype {
  PRESENCE_TYPES = 'presenceTypes',
  CURRENCY_TYPES = 'currencyTypes',
  PER_HOUR_TYPES = 'perHourTypes',
  ORGAN_RANK = 'organRank',
  PROFILE_REQUIRED = 'profileRequiredData',
  GENDER_TYPES = 'genderType',
  MARITAL_STATUS = 'maritalType',
  EDU_GRADES_TYPE = 'eduGradesType',
  MILITARY_SERVICE_TYPE = 'militaryServiceType',
  ACTIVITIES_TYPE = 'activitiesTypes'
}

@Injectable({
  providedIn: 'root'
})
export class DataTypeService {
  constructor() { }
  
  getViewValueDataType(type:type, value:string,which:string='0'){
    if(which=='0') return this.getObjectDataType(type,value)?.viewValue
    if(which=='1') return this.getObjectDataType(type,value)?.viewValue1
    if(which=='2') return this.getObjectDataType(type,value)?.viewValue2
  }
  getObjectDataType(type:type, value:string){
    let obj : any = null
    if(type==Etype.PRESENCE_TYPES) obj = presenceTypes.find((item)=>item.value==value || item.viewValue==value)
    if(type==Etype.GENDER_TYPES) obj = genderType.find((item)=>item.value==value || item.viewValue==value)
    if(type==Etype.ORGAN_RANK) obj = organRrank.find((item)=>item.value==value || item.viewValue==value)
    if(type==Etype.PROFILE_REQUIRED) obj = profileRequiredData.find((item)=>item.value==value || item.viewValue==value)
    if(type==Etype.MARITAL_STATUS) obj = maritalTypes.find((item)=>item.value==value || item.viewValue==value)
    if(type==Etype.CURRENCY_TYPES) obj = currencyTypes.find((item)=>item.value==value || item.viewValue==value)
    if(type==Etype.PER_HOUR_TYPES) obj = perHourTypes.find((item)=>item.value==value || item.viewValue==value)
    if(type==Etype.EDU_GRADES_TYPE) obj = eduGradesType.find((item)=>item.value==value || item.viewValue==value)
    if(type==Etype.MILITARY_SERVICE_TYPE) obj = militeryServiceType.find((item)=>item.value==value || item.viewValue==value)
    if(type==Etype.ACTIVITIES_TYPE) obj = activitiesTypes.find((item)=>item.value==value || item.viewValue==value)
    return obj
  }
}
